/* istanbul ignore next */
import { pushAlert } from '@/services/messages/alertService';
import translate from '@/services/translate';

const msis127ErrorHandler = {
  errorHandling: {
    ignore: errorData => errorData?.response?.data?.codigoMensagem === 'MSIS127',
  },
  msis127ErrorHandler: ({ response }) => {
    if (response?.data?.codigoMensagem === 'MSIS127') {
      pushAlert({ code: 'MA112' });
      throw new Error(translate('messages.MA112.message'));
    }
    throw response;
  },
};

export default msis127ErrorHandler;
